import React, {useEffect, useState} from "react";
import {Button, Table} from "antd";
import {DownloadOutlined} from "@ant-design/icons";
import axios from "axios";
import {API_URL} from "../../constants";
import {useSelector} from "react-redux";
import dayjs from "dayjs";
import moment from "moment-timezone";

const Backups = () => {
    const [list, setList] = useState([]);
    const token = useSelector((state) => state.user.currentUser?.accessToken);
    const getBackupsList = async () => {
        try {
            const res = await axios.get(API_URL +"user/gestionar/backups", {
                headers: { Authorization: "Bearer " + token },
            });
            const sorted = res.data.sort(
                (a, b) => new Date(b.createdDate) - new Date(a.createdDate)
            );
            setList(sorted);
        } catch (error) {
            console.log(error);
        }
    };
    useEffect(() => {
        getBackupsList();
    }, []);
    const download = async (record) => {
        try {
            console.log(record);
            const res = await axios.get(
                API_URL +"user/gestionar/download/backup/" + record.filename,
                {
                    headers: { Authorization: "Bearer " + token },
                    responseType: "blob",
                }
            );

            const blob = new Blob([res.data], {
                type: res.headers["content-type"],
            });

            const url = window.URL.createObjectURL(blob);

            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", record.filename);

            document.body.appendChild(link);
            link.click();

            link.parentNode.removeChild(link);
            window.URL.revokeObjectURL(url);

           // message.success("Backup descărcat cu succes!");
        } catch (error) {
            console.log(error);
          //  message.error("Eroare la descărcare backup: " + error.message);
        }
    }
    const mainColumns = [
        {
            title: "Creat la data de",
            dataIndex: "createdDate",
            key: "createdDate",
            render: (_, record) => (
                dayjs(_).format("YYYY-MM-DD HH:mm:ss")
            ),
        },
        {
            title: "Nume",
            dataIndex: "filename",
            key: "filename",
        },
        {
            title: "Actions",
            key: "edit",
            width: "50px",
            render: (_, record) => (
                <div className="d-flex gap-2 align-items-center">
                    <Button className="d-flex align-items-center" type="primary" onClick={() => download(record)}>
                        <DownloadOutlined />
                    </Button>
                </div>
            ),
        },
    ];

    return (
        <div className="d-flex gap-2 flex-column w-100">
            <Table
                columns={mainColumns}
                dataSource={list}
                rowKey="id"
            />
        </div>
    );
};

export default Backups;
